import { render, staticRenderFns } from "./default-old.vue?vue&type=template&id=51d38bae"
import script from "./default-old.vue?vue&type=script&lang=js"
export * from "./default-old.vue?vue&type=script&lang=js"
import style0 from "./default-old.vue?vue&type=style&index=0&id=51d38bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports